"use client"

import Image from "next/image"

interface AboutItem {
    title: string
    description: string
    image: string
}

const VisionSection = () => {
    // Danh sách dữ liệu hiển thị
    const items: AboutItem[] = [
        {
            title: "Vươn tầm quốc tế",
            description:
                "Với khát vọng nâng tầm giá trị du lịch và giải pháp logistics trong thời đại hội nhập, Rovi Holdings hướng đến phát triển một hệ sinh thái toàn diện, không ngừng tăng trưởng và vươn tầm quốc tế.",
            image: "/images/About/Background (1).png",
        },
        {
            title: "Công suất phục vụ 1,2 triệu khách hàng",
            description:
                "Cùng nhiều quỹ đầu tư cả nhân, Rovi Holdings lên kế hoạch triển khai mở rộng 5 khu vực bán hàng, 5 văn phòng chính và hơn 20 chi nhánh trên toàn quốc, nâng công suất phục vụ lên 1,2 triệu khách hàng.",
            image: "/images/About/Background (2).png",
        },
        {
            title: "Mục tiêu doanh thu 335 triệu đô",
            description: "Đặt mục tiêu doanh thu lên đến 335 triệu đô và biên độ lợi nhuận đạt 10%.",
            image: "/images/About/Background (3).png",
        },
    ]

    return (
        // Section tầm nhìn doanh nghiệp
        <section className="relative w-full min-h-screen flex items-center py-8 md:py-12 px-4 md:px-8 xl:p-8 2xl:p-10 min-[1920px]:p-14">

            {/* Layout tổng thể */}
            <div className="w-full max-w-6xl 2xl:max-w-7xl min-[1920px]:max-w-[90rem] grid grid-cols-1 lg:grid-cols-2 gap-6 xl:gap-12 2xl:gap-16 min-[1920px]:gap-24 items-center mx-auto pr-0 md:pr-16 xl:pr-24 2xl:pr-0">

                {/* Khối hiển thị hình ảnh chính */}
                <div className="flex justify-center xl:justify-end order-1 lg:order-none">
                    <div className="relative w-full max-w-[200px] md:max-w-[370px] 2xl:max-w-[420px] min-[1920px]:max-w-[500px] overflow-hidden">
                        <Image
                            src="/images/About/Background.png"
                            alt="About Us"
                            width={800}
                            height={1067}
                            className="w-full h-auto object-contain"
                            priority
                        />
                    </div>
                </div>

                {/* Khối nội dung tầm nhìn */}
                <div className="flex flex-col space-y-6 md:space-y-8 2xl:space-y-10 xl:pl-0 order-2 lg:order-none text-center lg:text-left">

                    {/* Tiêu đề khu vực */}
                    <div>
                        <p className="text-[10px] md:text-[11px] 2xl:text-xs min-[1920px]:text-sm font-normal tracking-widest text-[#006633] uppercase mb-1 md:mb-2">
                            Về chúng tôi
                        </p>
                        <h2
                            className="text-xl md:text-2xl xl:text-[27px] 2xl:text-[30px] min-[1920px]:text-4xl font-medium text-[#333333]"
                            style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
                        >
                            <span className="font-medium text-[#006633]">Tầm nhìn</span> của chúng tôi
                        </h2>
                    </div>

                    {/* Đường phân cách */}
                    <div className="border-t border-gray-200" />

                    {/* Danh sách nội dung tầm nhìn */}
                    <div className="space-y-6 md:space-y-8 2xl:space-y-10">
                        {items.map((item, index) => (
                            <div key={index}>

                                {/* Nhóm hiển thị từng mục */}
                                <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 md:gap-4 2xl:gap-6 min-[1920px]:gap-8 items-center justify-items-center xl:justify-items-start">

                                    {/* Nhóm ảnh đại diện và tiêu đề */}
                                    <div className="flex flex-col xl:flex-row items-center gap-2 xl:gap-4 2xl:gap-5 min-[1920px]:gap-6 max-w-full xl:max-w-[210px] 2xl:max-w-[240px] min-[1920px]:max-w-[280px]">
                                        <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 2xl:w-14 2xl:h-14 min-[1920px]:w-16 min-[1920px]:h-16 rounded-full bg-green-700 overflow-hidden">
                                            <Image
                                                src={item.image}
                                                alt={item.title}
                                                width={48}
                                                height={48}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                        <h3
                                            className="text-sm 2xl:text-[15px] min-[1920px]:text-lg font-semibold text-[#000000] mt-1 xl:mt-0"
                                            style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
                                        >
                                            {item.title}
                                        </h3>
                                    </div>

                                    {/* Nội dung mô tả */}
                                    <div
                                        className="text-[12px] 2xl:text-[13px] min-[1920px]:text-base text-[#2D3746] leading-tight max-w-2xl 2xl:max-w-3xl min-[1920px]:max-w-4xl ml-0 xl:-ml-10 2xl:-ml-8 min-[1920px]:-ml-6"
                                        style={{ fontFamily: '"Helvetica Neue", Roboto, sans-serif' }}
                                    >
                                        <p>{item.description}</p>
                                    </div>
                                </div>

                                {/* Đường phân cách giữa các mục */}
                                {index < items.length - 1 && (
                                    <div className="mt-6 md:mt-8 2xl:mt-10 border-t border-gray-200" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default VisionSection
